export default __webpack_public_path__ + "static/media/unsplash.e26f8f21.svg";